import { css } from '@rxdi/lit-html';

/**
 * Studio look for @rxdi/ui-kit modals (injected into the kit's modal shadow
 * root through `openCustomModal({ style })`). Colours from theme variables.
 */
export const StudioModalStyle = css`
  .backdrop {
    background: var(--rs-scrim);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
  }

  .container {
    min-height: 100%;
    display: grid;
    place-items: center;
    padding: 24px 16px;
    box-sizing: border-box;
  }

  .dialog {
    width: min(480px, 100%) !important;
    padding: 0 !important;
    color: var(--rs-text-2);
    background: var(--rs-gradient-card), var(--rs-surface) !important;
    border: 1px solid var(--rs-line-strong);
    border-radius: var(--rs-radius-lg);
    box-shadow: var(--rs-shadow-lg) !important;
    overflow: hidden;
    font-family: var(--rs-font-body);
  }

  .close-button {
    top: 14px !important;
    right: 14px !important;
    width: 32px;
    height: 32px;
    border-radius: 10px;
    color: var(--rs-text-2);
    opacity: 1 !important;
  }

  .close-button:hover {
    color: var(--rs-text);
    background: var(--rs-line) !important;
  }

  .close-button svg,
  .close-button * {
    fill: currentColor;
    stroke: currentColor;
  }
`;

/** Shared styles for forms shown inside a studio modal. */
export const StudioModalFormStyles = css`
  :host {
    display: block;
    color: var(--rs-text-2);
    font-family: var(--rs-font-body);
  }

  * {
    box-sizing: border-box;
  }

  header {
    padding: 26px 26px 6px;
  }

  .kicker {
    font-family: var(--rs-font-mono);
    font-size: 11px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--rs-signal);
  }

  h2 {
    margin: 8px 0 6px;
    font-family: var(--rs-font-display);
    font-size: 26px;
    letter-spacing: -0.02em;
    color: var(--rs-text);
  }

  header p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: var(--rs-text-muted);
  }

  .body {
    display: grid;
    gap: 16px;
    padding: 18px 26px 6px;
  }

  label {
    display: grid;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: var(--rs-text);
  }

  input,
  select {
    width: 100%;
    height: 44px;
    padding: 0 14px;
    border-radius: 12px;
    border: 1px solid var(--rs-line-strong);
    background: var(--rs-ink-2);
    color: var(--rs-text);
    font: 400 15px var(--rs-font-body);
  }

  input:focus,
  select:focus {
    outline: none;
    border-color: var(--rs-signal);
  }

  input:disabled {
    opacity: 0.6;
  }

  .is-invalid {
    border-color: var(--rs-ember) !important;
  }

  .error {
    font-size: 12px;
    font-weight: 500;
    color: var(--rs-ember);
  }

  footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 22px 26px 26px;
  }

  button {
    height: 44px;
    padding: 0 20px;
    border-radius: 999px;
    font: 600 14px var(--rs-font-body);
    cursor: pointer;
  }

  button.ghost {
    border: 1px solid var(--rs-line-strong);
    background: transparent;
    color: var(--rs-text);
  }

  button.ghost:hover {
    border-color: var(--rs-text-muted);
  }

  button.primary {
    border: 1px solid var(--rs-signal);
    background: var(--rs-signal);
    color: var(--rs-text-on-accent);
  }

  button.primary:hover {
    box-shadow: var(--rs-shadow-signal);
  }
`;
